import { formatTimestamp } from "../utils/timestamps.mjs";
import React from "react";
import { reactivationInactivity } from "../services/commercial.mjs";
import { formatDate, todayParis } from "../crm.mjs";
import { Panel, Empty } from "../components/ui";
export default function Reactivation({ state, onClient }) {
  const today = todayParis();
  const clients = state.clients.filter(client => reactivationInactivity(client, today));
  return (
    <>
      <Panel title="Réactivation des clients">
        <p className="hint">Clients ayant commandé au cours des 12 derniers mois, sans nouvelle commande depuis au moins 30 jours.</p>
      </Panel>
      {clients.length > 0 && (
        <Panel title="Clients à réactiver">
          <div className="tableScroll">
            <table className="taskTable reactivationList">
              <thead><tr><th>Client</th><th>Statut</th><th>Situation</th><th>Priorité</th><th>Action</th></tr></thead>
              <tbody>
                {[...clients].sort((a, b) => b.score - a.score).map(c => (
                  <tr key={c.id}>
                    <td><b>{c.name}</b><small>{c.city}</small></td>
                    <td><span className="status">{c.status}</span></td>
                    <td>{`Dernière commande : ${formatDate(reactivationInactivity(c, today).lastOrder)} · ${reactivationInactivity(c, today).days} jours sans commande`}{c.lossReason && <small>{formatTimestamp(c.lossReasonAt)}</small>}</td>
                    <td><b>{c.score}/100</b></td>
                    <td><button className="tableAction" onClick={() => onClient(c.id)}>Saisir le résultat de mon appel</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Panel>
      )}
      {!clients.length && <Empty>Aucun client dans cette catégorie.</Empty>}
    </>
  );
}
